import React, { useRef } from 'react'
import * as tus from 'tus-js-client'
import { eventPubSub } from "../../../Helpers";
import { useResourceManager } from "../../hooks/useResourceManager";
import { ResourceTypes } from "../../software-notification/interfaces/notification-data.interface";
import { hubConnectionString, projectHubConnection } from "../api";
import { useMutationDownloadAndInstall, useMutationInstallSnape, useMutationRollback, useMutationUpdateFirmware } from "../queries/softwareUpdateQueries";
import { installationProcessModel } from '../components/InstallationProcessModel';
import { isError } from 'react-query';
import { useMutationGetInstallationStatus } from '../../software-notification/queries';

var isFirstInstallPhaseError = false;
var isFirstPhaseComplete = false;
var isUploadComplete = false;
let uploadPackageHubConn;

export const useSoftwareUpdate = () => {
    const { GatewaySettingsJS, SnapeHelperScriptsJS } = useResourceManager() as any
    const { publish } = eventPubSub
    const {
        mutateAsync: mutateDownloadAndInstall
    } = useMutationDownloadAndInstall()
    const {
        mutateAsync: mutateRollback
    } = useMutationRollback()
    const {
        mutateAsync: mutateInstalaltionStatus
    } = useMutationGetInstallationStatus()

    const isUploadHappening = useRef(false)


    const initDownloadConnection = () => {
        if (!(window as any).telemetryConnection) {
            const interval = setInterval(() => {
                if ((window as any).SnapeApp.Helpers.SignalrClient) {
                    const telemetryConnection = (window as any).SnapeApp.Helpers.SignalrClient.createConnector(hubConnectionString);
                    (window as any).telemetryConnection = telemetryConnection 

                    telemetryConnection.on("DownloadProgressUpdated", function (percentage: string, message: string) {
                        const progress = parseFloat(percentage.toString())

                        publish('InstallationProgressCallback', {});

                        if (progress < 100) {
                            publish('DownloadingPackage', {
                                type: SnapeHelperScriptsJS.DownloadingPackage,
                                progress,
                                isError: false,
                                subText: (message !== null && message !== undefined && message !== "") ? (window as any).Resources.GatewaySettingsJS[message] : GatewaySettingsJS.DownloadInstallationFile,
                            })
                        } else {
                            if (isFirstInstallPhaseError) {
                                publish('DownloadingPackage', {
                                    type: SnapeHelperScriptsJS.DownloadingPackage,
                                    progress: 100,
                                    subText: GatewaySettingsJS.InstallationFailed,
                                    isError: true,
                                    shouldHideRetryButton: false
                                })
                                publish('InstallationErrorCallback', {});
                            } else {
                                publish('DownloadingPackage', {
                                    type: SnapeHelperScriptsJS.DownloadingPackage,
                                    progress: 100,
                                    subText: (message !== null && message !== undefined && message !== "") ? (window as any).Resources.GatewaySettingsJS[message] : GatewaySettingsJS.DownloadInstallationFile,
                                    isError: false,
                                    shouldHideRetryButton: true
                                })
                            }
                        }

                        const result = message.split('#')[2]

                        const type = message.split('#')[1]

                        if (result && progress >= 100) {
                            if (result === "0") {
                                (window as any).SnapeApp.Helpers.UIOperations.showMessage(type + GatewaySettingsJS.SystemUpdatedStatus, true, "toast-bottom-left");
                                publish('CloseSoftwareUpdateScreen', {})
                                installationProcessModel.reset();
                            } else if (result === "2") {
                                publish('DownloadingPackage', {
                                    type: SnapeHelperScriptsJS.DownloadingPackage,
                                    progress: 100,
                                    subText: GatewaySettingsJS.FileNotFound,
                                    isError: true,
                                    shouldHideRetryButton: false
                                });
            
                                (window as any).SnapeApp.Helpers.UIOperations.showMessage(GatewaySettingsJS.FileNotFound, false, "toast-bottom-left");
                                publish('InstallationErrorCallback', {});
                            } else {
                                publish('DownloadingPackage', {
                                    type: SnapeHelperScriptsJS.DownloadingPackage,
                                    progress: 100,
                                    subText: GatewaySettingsJS.InstallationFailed,
                                    isError: true,
                                    shouldHideRetryButton: false
                                });
                                publish('InstallationErrorCallback', {});
                                (window as any).SnapeApp.Helpers.UIOperations.showMessage(GatewaySettingsJS.InternetUnavailable, false, "toast-bottom-left");
                            }
                        }
                    });

                    telemetryConnection.on("UploadProgressUpdated", function (percentage: string, message: string) {
                        const   progress = parseFloat(percentage.toString())

                        publish('InstallationProgressCallback', {});

                        if (message === "Upload Error" && isFirstInstallPhaseError === undefined) {
                            publish('UploadingPackage', {
                                type: SnapeHelperScriptsJS.UploadingPackage,
                                progress,
                                subText: GatewaySettingsJS.InstallationFailed,
                                isError: true,
                                shouldHideRetryButton: true
                            });
                        }
                        

                        if (progress < 100 && !isUploadHappening.current) {
                            publish('UploadingPackage', {
                                type: SnapeHelperScriptsJS.UploadingPackage,
                                progress,
                                subText: GatewaySettingsJS.UploadInstallationFile,
                                isError: false
                            });
                        } 
                        
                        if (progress >= 100) {
                            if (message !== 'Upload Error') {
                                publish('UploadingPackage', {
                                    type: SnapeHelperScriptsJS.UploadingPackage,
                                    progress: 100,
                                    subText: (message !== null && message !== undefined && message !== "") ? (window as any).Resources.GatewaySettingsJS[message] : GatewaySettingsJS.UploadInstallationFile,
                                    isError: false,
                                    shouldHideRetryButton: true
                                });
                            }
                        }


                        if (message === "Upload Error") {
                            setTimeout(() => {
                                publish('UploadingPackage', {
                                    type: SnapeHelperScriptsJS.UploadingPackage,
                                    progress,
                                    subText: GatewaySettingsJS.InstallationFailed,
                                    isError: true,
                                    shouldHideRetryButton: !isUploadHappening.current
                                });
                            }, 1000)
                    
                        }
                    });

                    telemetryConnection.on("RollbackProgressUpdated", function (percentage: string, message: string) {
                        const progress = parseFloat(percentage.toString())

                        publish('InstallationProgressCallback', {});

                        if (progress < 100) {
                            publish('ProcessingRollback', {
                                type: SnapeHelperScriptsJS.ProcessingRollback,
                                progress,
                                isError: false,
                                subText: GatewaySettingsJS.CopyInstallationFile,
                            });
                        } else {
                            if (isFirstInstallPhaseError) {
                                publish('ProcessingRollback', {
                                    type: SnapeHelperScriptsJS.ProcessingRollback,
                                    progress,
                                    subText: GatewaySettingsJS.InstallationFailed,
                                    isError: true,
                                    shouldHideRetryButton: false
                                });
                                publish('InstallationErrorCallback', {});
                            } else {
                                publish('ProcessingRollback', {
                                    type: SnapeHelperScriptsJS.ProcessingRollback,
                                    progress: 100,
                                    subText: GatewaySettingsJS.CopyInstallationFile,
                                    isError: false,
                                    shouldHideRetryButton: true
                                });
                            }
                        }

                        isFirstPhaseComplete = isFirstPhaseComplete || (progress === 100);
                    });

                    telemetryConnection.on("SnapeInstallProgress", function (percentage: string, message: string) {
                        const progress = parseFloat(percentage.toString())

                        if (progress < 100) {
                            publish('InstallationProgressCallback', {});
                        } 

                        if (progress === 100) {
                            publish('onSoftwareUpdateNotificationSucceed', {})
                        }

                        if (message === GatewaySettingsJS.InstallationSuccessStatus) {

                            publish('InstallSnapePackage', {
                                type: SnapeHelperScriptsJS.InstallSnapePackage,
                                progress: 100,
                                isError: false,
                                shouldHideRetryButton: false
                            });

                            publish('InstallationCompleteCallback', {});

                            setTimeout(() => {
                                publish('InstallationFinished', {
                                    type: SnapeHelperScriptsJS.InstallationFinished,
                                    progress: 100,
                                    isError: false,
                                    shouldHideRetryButton: false
                                })
                            }, 100);

                            publish('CloseSoftwareUpdateScreen', {});
                            installationProcessModel.reset();
                            publish('CloseSoftwareUpdateModal', {}); //close the version tile modal after successful installation

                            (window as any).SnapeApp.Helpers.UIOperations.showMessage(GatewaySettingsJS.InstallationSuccess, true, "toast-bottom-left");
                            setTimeout(() => {
                                window.location.replace("/Account/Login");
                            }, 500)

                        } else if (message === GatewaySettingsJS.InstallationFailedStatus) {
                            publish('InstallSnapePackage', {
                                type: SnapeHelperScriptsJS.InstallSnapePackage,
                                isError: true,
                                progress: 100
                            });

                            publish('CloseSoftwareUpdateScreen', {});
                            installationProcessModel.reset();
                            publish('CloseSoftwareUpdateModal', {}); //close the version tile modal

                            (window as any).SnapeApp.Helpers.UIOperations.showMessage(GatewaySettingsJS.InstallationFailed, false, "toast-bottom-left");
                            publish('InstallationErrorCallback', {});

                        } else if (message === GatewaySettingsJS.SnapeInstallFailed || message === GatewaySettingsJS.SnapeInstallTerminated) {
                            publish('InstallSnapePackage', {
                                type: SnapeHelperScriptsJS.InstallSnapePackage,
                                subText: message,
                                isError: true,
                                progress: 100
                            });

                            publish('CloseSoftwareUpdateScreen', {});
                            installationProcessModel.reset();
                            publish('CloseSoftwareUpdateModal', {}); //close the version tile modal

                            (window as any).SnapeApp.Helpers.UIOperations.showMessage(GatewaySettingsJS.InstallationFailed, false, "toast-bottom-left");
                            publish('InstallationErrorCallback', {});
                        } else {
                            publish('InstallSnapePackage', {
                                type: SnapeHelperScriptsJS.InstallSnapePackage,
                                progress,
                                subText: message,
                                isError: false,
                                shouldHideRetryButton: false
                            });
                        }

                        const result = message.split('#')[1]

                        if (result) {
                            if (result === "400") {
                                setTimeout(() => {
                                    publish('InstallSnapePackage', {
                                        type: SnapeHelperScriptsJS.InstallSnapePackage,
                                        progress: 100,
                                        subText: GatewaySettingsJS.PackageInstallFailedInternet,
                                        isError: true,
                                        shouldHideRetryButton: false
                                    });
                                }, 100);
            
                                (window as any).SnapeApp.Helpers.UIOperations.showPersistentMessage(GatewaySettingsJS.PackageInstallFailedInternet, false, "toast-bottom-left");
                            } else if (result === "-1") {
                                let disableRetry = true;
                                let errSubTxt = GatewaySettingsJS.PackageInstallCorrupt;
            
                                setTimeout(() => {
                                    publish('InstallSnapePackage', {
                                        type: SnapeHelperScriptsJS.InstallSnapePackage,
                                        progress: 100,
                                        subText: errSubTxt,
                                        isError: true,
                                        shouldHideRetryButton: disableRetry
                                    });
            
                                }, 100);
                                (window as any).SnapeApp.Helpers.UIOperations.showPersistentMessage(GatewaySettingsJS.PackageInstallCorrupt, false, "toast-bottom-left");
                            } else {
                                if (result !== "200") { // Other Errors
                                    setTimeout(() => {
                                        publish('InstallSnapePackage', {
                                            type: SnapeHelperScriptsJS.InstallSnapePackage,
                                            progress: 100,
                                            subText: GatewaySettingsJS.PackageInstallFailed,
                                            isError: true,
                                            shouldHideRetryButton: false
                                        });
                                    }, 100);
                                    (window as any).SnapeApp.Helpers.UIOperations.showPersistentMessage(GatewaySettingsJS.PackageInstallFailed, false, "toast-bottom-left");
                                }
                            }
                        }
                  
                    });

                    telemetryConnection.on("MeshInstallProgress", function (percentage: string, message: string) {
                        const progress = parseFloat(percentage.toString())

                        if (progress < 100) {
                            publish('InstallationProgressCallback', {});
                        } else {
                            publish('InstallationCompleteCallback', {});
                        }
                        if (message === GatewaySettingsJS.MeshInstallationFinished || message === GatewaySettingsJS.FirmwareUpdateFailed) {
                            isFirstPhaseComplete = false;
                        } else {
                            publish('InstallMeshUpdate', {
                                type: SnapeHelperScriptsJS.InstallMeshUpdate,
                                progress,
                                subText: message,
                                isError: false,
                                shouldHideRetryButton: false
                            });
                        }

                        const result = message.split('#')[1]

                        const versionFirmwareName = message.split('#')[2]

                        if (result) {
                            if (result === "200") {
                                publish('CloseSoftwareUpdateScreen', {});  // localize package extraction success
                                installationProcessModel.reset();
                                publish('CloseSoftwareUpdateModal', {}); //close the version tile modal after successful installation
                                (window as any).SnapeApp.Helpers.UIOperations.showMessage(GatewaySettingsJS.FirmwareSuccessfullyUploadedAndInstalled, true, "toast-bottom-left");
                                isFirstPhaseComplete = false;
                                if (document.querySelector('#rfVersion')) {
                                    (document.querySelector('#rfVersion') as HTMLElement).innerHTML = versionFirmwareName
                                }
                
                                setTimeout(() => {
                                    window.location.reload();
                                }, 500)
                
                            } else if (result === "501") {
                                publish('InstallMeshUpdate', {
                                    type: SnapeHelperScriptsJS.InstallMeshUpdate,
                                    progress: 100,
                                    subText: GatewaySettingsJS.GwFirmwareUpdateUnsupportedGateway,
                                    isError: true,
                                    shouldHideRetryButton: false
                                });
                                (window as any).SnapeApp.Helpers.UIOperations.showPersistentMessage(GatewaySettingsJS.GwFirmwareUpdateUnsupportedGateway, false, "toast-bottom-left");
                                isFirstPhaseComplete = false;
                            } else if (result === "505") {
                                publish('InstallMeshUpdate', {
                                    type: SnapeHelperScriptsJS.InstallMeshUpdate,
                                    progress: 100,
                                    subText: GatewaySettingsJS.SelectedFirmwareVersionIncompatible,
                                    isError: true,
                                    shouldHideRetryButton: false
                                });
                                (window as any).SnapeApp.Helpers.UIOperations.showPersistentMessage(GatewaySettingsJS.SelectedFirmwareVersionIncompatible, false, "toast-bottom-left");
                                isFirstPhaseComplete = false;
                            } else { // result is something else
                                publish('InstallMeshUpdate', {
                                    type: SnapeHelperScriptsJS.InstallMeshUpdate,
                                    progress: 100,
                                    subText: GatewaySettingsJS.GwFirmwareUpdateFail,
                                    isError: true,
                                    shouldHideRetryButton: false
                                });
                                (window as any).SnapeApp.Helpers.UIOperations.showPersistentMessage(GatewaySettingsJS.GwFirmwareUpdateFail, false, "toast-bottom-left");
                                isFirstPhaseComplete = false;
                            }
                        }
                    });

                    telemetryConnection.on("UploadProgressUpdated", function (percentage: string, message: string) {
                        if (message === 'Upload Error') {
                            publish('InstallationErrorCallback', {});
                        }
                    });

                    (window as any).SnapeApp.Helpers.SignalrClient.startConnection(telemetryConnection);
                    clearInterval(interval)
                }
            }, 100)
        }

    }

    const initUploadPackageHub = () => {
        if (!uploadPackageHubConn) {
            const uploadPackageHub = (window as any).SnapeApp.Helpers.SignalrClient.createConnector('/uploadPackageHub');
            
            (window as any).SnapeApp.Helpers.SignalrClient.startConnection(uploadPackageHub);
            uploadPackageHubConn = uploadPackageHub
        }
    }

    const initProjectSyncHub = () => {
        const interval = setInterval(() => {
            if ((window as any).SnapeApp.Helpers.SignalrClient) {
                const telemetryConnection = (window as any).SnapeApp.Helpers.SignalrClient.createConnector(projectHubConnection);
                telemetryConnection.on("NotifyProjectSyncFinished", function (message: string) {
                    publish('onRefetchSoftwareUpdateNotification', {})
                });
                (window as any).SnapeApp.Helpers.SignalrClient.startConnection(telemetryConnection);
                clearInterval(interval)
            }
        }, 100)
    }

    const downloadAndInstallApi = (
        resourceType: ResourceTypes,
        releaseType: number,
        version: string,
        hwVersion: string,
        updateTypes: Record<string, number>) => {
        publish('ShowSoftwareUpdateScreen', {})
        var packageMode: number;
        var softwareType: string;
        isFirstInstallPhaseError = false;
        isFirstPhaseComplete = false;

        initUploadPackageHub()

        setTimeout(() => {
            publish('DownloadingPackage', {
                type: SnapeHelperScriptsJS.DownloadingPackage,
                progress: 1,
                subText: GatewaySettingsJS.DownloadInstallationFile,
                isError: false,
            });
        }, 100)

        if (resourceType === "Mesh") {
            packageMode = updateTypes.firmwareUpdate;
            softwareType = "Mesh ";
        } else {
            packageMode = updateTypes.packageUpdate;
            softwareType = "Snape ";
        }

        mutateDownloadAndInstall({ packageMode, releaseType, version, hwVersion })
            .catch((err) => {
                isFirstInstallPhaseError = true;

                if (err.message && (err.message.includes("504") || err.message.toLowerCase().includes("gateway timeout") ||
                    err.message.toLowerCase().includes("gateway time-out") || err.message.toLowerCase().includes("timeout") ||
                    err.message.toLowerCase().includes("time-out")) || err.message.toLowerCase().includes("did not receive json, instead received: gateway timeout(socket - link)")) {
                    (window as any).SnapeApp.Helpers.UIOperations.showGatewayConnection(GatewaySettingsJS.SnapeHelperScriptsJS.GatewayConnectionLost, "toast-bottom-left");

                    publish('DownloadingPackage', {
                        type: SnapeHelperScriptsJS.DownloadingPackage,
                        progress: 100,
                        subText: GatewaySettingsJS.InstallationFailedConnection,
                        isError: true,
                        shouldHideRetryButton: true
                    });
                } else {
                    publish('DownloadingPackage', {
                        type: SnapeHelperScriptsJS.DownloadingPackage,
                        progress: 100,
                        subText: GatewaySettingsJS.InstallationFailed,
                        isError: true,
                        shouldHideRetryButton: false
                    });
                }
                (window as any).SnapeApp.Helpers.UIOperations.showMessage(GatewaySettingsJS.InstallationFailed, false, "toast-bottom-left");
            });
    };

    var rollbackOption = function (fileName: string, packageUpdateType: number, releaseType: string) {
        isFirstInstallPhaseError = false;
        isFirstPhaseComplete = false;

        publish('ShowSoftwareUpdateScreen', {});

        if (packageUpdateType == (window as any).updateTypes.packageUpdate) {
            publish('ChangeSoftwareUpdateText', { subText: GatewaySettingsJS.PackageInstallingMsg })
        } else {
            publish('ChangeSoftwareUpdateText', { subText: GatewaySettingsJS.FirmwareInstallingMsg })
        }

        setTimeout(() => {
            // update uploading file step
            if (packageUpdateType == (window as any).updateTypes.packageUpdate) {
                publish('InstallSnapePackage', {
                    type: SnapeHelperScriptsJS.InstallSnapePackage,
                    progress: 1,
                    subText: "",
                    isError: false
                });
            } else {
                publish('InstallSnapePackage', {
                    type: SnapeHelperScriptsJS.InstallMeshUpdate,
                    progress: 1,
                    isError: false,
                    subText: ""
                });
            }
           
        }, 100)

        initUploadPackageHub()
        mutateRollback({
            fileName,
            releaseType
        }).catch((err) => {
            isFirstInstallPhaseError = true;

            if (err.message && (err.message.includes("504") || err.message.toLowerCase().includes("gateway timeout") ||
                err.message.toLowerCase().includes("gateway time-out") || err.message.toLowerCase().includes("timeout") ||
                err.message.toLowerCase().includes("time-out")) || err.message.toLowerCase().includes("did not receive json, instead received: gateway timeout(socket - link)")) {
                (window as any).SnapeApp.Helpers.UIOperations.showGatewayConnection(GatewaySettingsJS.SnapeHelperScriptsJS.GatewayConnectionLost, "toast-bottom-left");

                publish('ProcessingRollback', {
                    type: SnapeHelperScriptsJS.ProcessingRollback,
                    progress: 100,
                    isError: true,
                    subText: GatewaySettingsJS.InstallationFailedConnection,
                    shouldHideRetryButton: true
                });


            } else {
                publish('ProcessingRollback', {
                    type: SnapeHelperScriptsJS.ProcessingRollback,
                    progress: 100,
                    isError: true,
                    subText: GatewaySettingsJS.InstallationFailed,
                    shouldHideRetryButton: false
                });
            }
        });
    };

    var uploadFile = function (file: File, packageUpdateType: number) {
        isFirstInstallPhaseError = false;
        isFirstPhaseComplete = false;

        let filename = file.name;
        let fileversion = "";

        initUploadPackageHub()
    
        if (packageUpdateType === (window as any).updateTypes.packageUpdate) {
            fileversion = filename.split("-")[1].split(".zip")[0].split(" ")[0].substring(1);
        } else {
            fileversion = filename.split("_")[3].split(".bin")[0].split(" ")[0].substring(1);
        }

        let formData = new FormData();

        formData.append("files", file);

        // show softwae update is progressing modal
        publish('ShowSoftwareUpdateScreen', {});

        initDownloadConnection();

        let uploadInterval;

        // Create a new tus upload
        var upload = new tus.Upload(file, {
            endpoint: '/api/resumable/upload?type=' + encodeURIComponent(packageUpdateType) + '&version=' + encodeURIComponent(fileversion) + '&filename=' + encodeURIComponent(file.name),
            retryDelays: [], //disable auto-retry attempts
            metadata: {
                filename: filename,
                filetype: file.type,
                filesize: file.size as any,
            },
            fileid: file.name as any,
            onError: function (error) {
                isUploadComplete = false;
                clearInterval(uploadInterval);
                // Extract the response code from the error.message
                const match = error.message.match(/response code: (\d+)/);
                const statusCode = match ? parseInt(match[1], 10) : null;
                if (statusCode === 409) {
                   alert(SnapeHelperScriptsJS.AnotherInstallationStillGoingOn)
                } else if(statusCode === 302) {
                    publish('UploadingPackage', {
                        type: SnapeHelperScriptsJS.UploadingPackage,
                        progress: 1,
                        subText: "Package is found. Started installation process",
                        isError: false,
                        shouldHideRetryButton: false
                    }); 
                    setTimeout(() => {
                        publish('UploadingPackage', {
                            type: SnapeHelperScriptsJS.UploadingPackage,
                            progress: 100,
                            subText: "Package is found. Started installation process",
                            isError: false,
                            shouldHideRetryButton: false
                        }); 
                    }, 100)
                } else {
                     uploadPackageHubConn?.invoke("OnUploadError", 'error')

                    isFirstInstallPhaseError = true;

                    if (error.message && (error.message.includes("504") || error.message.toLowerCase().includes("gateway timeout") ||
                        error.message.toLowerCase().includes("gateway time-out") || error.message.toLowerCase().includes("timeout") ||
                        error.message.toLowerCase().includes("time-out") || error.message.toLowerCase().includes("did not receive json, instead received: gateway timeout(socket - link)")) || statusCode === 504) {
                        (window as any).SnapeApp.Helpers.UIOperations.showGatewayConnection(GatewaySettingsJS.SnapeHelperScriptsJS.GatewayConnectionLost, "toast-bottom-left");

                        let subTextMessage = "";
                        if (packageUpdateType == (window as any).updateTypes.packageUpdate) {
                            subTextMessage = GatewaySettingsJS.FailedUploadingThePackage;
                        } else {
                            subTextMessage = GatewaySettingsJS.FailedUploadingTheFirmware;
                        }
                        publish('UploadingPackage', {
                            type: SnapeHelperScriptsJS.UploadingPackage,
                            progress: 100,
                            subText: subTextMessage,
                            isError: true,
                            shouldHideRetryButton: true
                        });
                    } else {
                        let subTextMessage = "";
                        if (packageUpdateType == (window as any).updateTypes.packageUpdate) {
                            subTextMessage = GatewaySettingsJS.FailedUploadingThePackage;
                        } else {
                            subTextMessage = GatewaySettingsJS.FailedUploadingTheFirmware;
                        }
                        publish('UploadingPackage', {
                            type: SnapeHelperScriptsJS.UploadingPackage,
                            progress: 100,
                            subText: subTextMessage,
                            isError: true,
                            shouldHideRetryButton: false
                        });
                        isFirstPhaseComplete = false;
                    }
                }
            },
            onProgress: function (bytesUploaded, bytesTotal) {
                var percentage = Math.floor(((bytesUploaded / bytesTotal) * 100) / (packageUpdateType === 2 ? 2 : 1)).toString(); 

                (window as any).isUploadHappening = true
                isUploadHappening.current = true;
                if (!isUploadComplete && !isFirstPhaseComplete) {
                    publish('UploadingPackage', {
                        type: SnapeHelperScriptsJS.UploadingPackage,
                        progress: percentage,
                        subText: GatewaySettingsJS.UploadInstallationFile,
                        isError: false,
                        shouldHideRetryButton: false
                    });
                
                    uploadPackageHubConn?.invoke("OnUploadError", `progress#${percentage}`)
                }

                isUploadComplete = isUploadComplete || (packageUpdateType === 2 ? parseFloat(percentage) === 50 : parseFloat(percentage) === 100);
            },
            onSuccess: function () {
                isUploadComplete = false;
                isUploadHappening.current = false;
                (window as any).isUploadHappening = false;
                clearInterval(uploadInterval);
            },
            removeFingerprintOnSuccess: true
        })

        // Check if there are any previous uploads to continue.
        upload.findPreviousUploads().then(async function (previousUploads) {
            // Found previous uploads so we select the first one.

            const instalaltionStatus = await mutateInstalaltionStatus()

            if (instalaltionStatus === "InstallationStarted") {
                alert(SnapeHelperScriptsJS.AnotherInstallationStillGoingOn)
            } else {
                if (previousUploads.length) {
                    upload.resumeFromPreviousUpload(previousUploads[0])
                }

                uploadInterval = setInterval(() => {
                    if ((window as any).telemetryConnection) {
                        (window as any).telemetryConnection.invoke('SendUploadIntervalProgress', "-1")
                    }
                }, 1000)
    
                // Start the upload
                upload.start()
            }

        

      
        })

        setTimeout(() => {
            // update uploading file step
            publish('UploadingPackage', {
                type: SnapeHelperScriptsJS.UploadingPackage,
                progress: 1,
                isError: false
            });
        }, 100)


        // update software update screen sub heading text
        if (packageUpdateType == (window as any).updateTypes.packageUpdate) {
            publish('ChangeSoftwareUpdateText', { subText: GatewaySettingsJS.PackageInstallingMsg })
        } else {
            publish('ChangeSoftwareUpdateText', { subText: GatewaySettingsJS.FirmwareInstallingMsg })
        }

    };

    var uploadPackage = function (file: File, packageUpdateType: number, rollbackValue?: { fileName: string, releaseType: string }) {
        if (rollbackValue) {
            if (rollbackValue.fileName.includes(".bin") && rollbackValue.fileName.includes("BEAM_GW_H") && rollbackValue.fileName.includes("_V")) {
                const action = () => rollbackOption(rollbackValue.fileName, (window as any).updateTypes.firmwareUpdate, rollbackValue.releaseType);
                (window as any).prevSoftwareUpdateAction = action;
                action()
            }
            else if (rollbackValue.fileName.includes(".zip") && rollbackValue.fileName.includes("snapeserver-v")) {
                const action = () => rollbackOption(rollbackValue.fileName, (window as any).updateTypes.packageUpdate, rollbackValue.releaseType);
                (window as any).prevSoftwareUpdateAction = action;
                action()
            }
            else {
                return;
            }

        } else if (file === undefined && file === null) {
            return;
        }
        else {
            const action = () => uploadFile(file, packageUpdateType);
            (window as any).prevSoftwareUpdateAction = action;
            action()
        }
    };


    return {
        downloadAndInstallApi,
        initDownloadConnection,
        uploadPackage,
        initProjectSyncHub
    }
}